<template>
    <FutureDeliveryRequests
        v-if="loaded"
        :excluded-columns="excludedColumns"
        :future-deliveries="futureDeliveryRequests"
        :show-add-button="hasClientRole"
        :selected-future-delivery-request="selectedFutureDeliveryRequest"
        :show-future-delivery-request-summary="showFutureDeliveryRequestSummary"
        @update:showFutureDeliveryRequestSummary="
            showFutureDeliveryRequestSummary = $event
        "
        @futureDeliveryRequestRowClicked="futureDeliveryRequestRowClicked"
    />
</template>

<script>
import { mapActions } from "vuex";
import store from "./_store";
import FutureDeliveryRequests from "./_components/FutureDeliveryRequests";
import { getters } from "src/global-store.js";
import api from "src/services/api.js";

export default {
    name: "FutureDeliveryRequestsModule",
    components: {
        FutureDeliveryRequests,
    },
    data() {
        return {
            loaded: false,
            showFutureDeliveryRequestSummary: false,
            selectedFutureDeliveryRequest: {},
            futureDeliveryRequests: [],
        };
    },
    computed: {
        hasClientRole() {
            return getters.hasClientRole();
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
        excludedColumns() {
            const columns = [];
            if (this.isCustomer) columns.push("Customer");
            if (this.isDesigner) columns.push("Designer");
            const some = this.futureDeliveryRequests
                .map((r) => r.designer_name)
                .filter((r) => r != null);
            if (some.length == 0) {
                columns.push("Designer");
            }
            console.log(some);
            return columns;
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_futureDeliveryRequest", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_futureDeliveryRequest");
    },
    async created() {
        // await this.fetchFutureDeliveryRequests();
        try {
            this.futureDeliveryRequests = await api.get(
                "/future-delivery-requests",
            );
        } catch (error) {
            console.error(error);
        }
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_futureDeliveryRequest", [
            "fetchFutureDeliveryRequests",
            "fetchFutureDeliveryRequest",
        ]),
        async futureDeliveryRequestRowClicked(row) {
            const request = await this.fetchFutureDeliveryRequest(row.id);
            this.selectedFutureDeliveryRequest = request;
            this.selectedFutureDeliveryRequest.requestDetails =
                request.requestDetails.map((d) => ({
                    ...d,
                    quantity: String(d.quantity),
                }));
            this.showFutureDeliveryRequestSummary = true;
        },
    },
};
</script>
